// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".editor-body-input{width:calc(100% - 35px)!important}", "",{"version":3,"sources":["webpack://./resources/js/app/Component/Helper/Editor/Editor.vue"],"names":[],"mappings":"AACA,mBACI,iCAAJ","sourcesContent":["\n.editor-body-input {\n    width: calc(100% - 35px) !important;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
